import { CURRENT_STATUS } from '@utils/translation'

export const AMBASSADOR_USER_TYPE_KEY = 'ambassadorUserType'

export const AMBASSADOR_APPROVED_AT_KEY = 'ambassadorApprovedAt'

export interface GlobalEventProperties {
  platform: string
  ambassador_user_id: string
  user_type: string
  programme_type: string
  application_status: string
  coupon_status: string
}

interface AmbassadorProfile {
  programType?: string
  applicationStatus?: string
  couponStatus?: string
  programme_type?: string
}

const getProfile = (): AmbassadorProfile => {
  try {
    return JSON.parse(localStorage.getItem(CURRENT_STATUS) || '{}') as AmbassadorProfile
  } catch {
    return {}
  }
}

const getPlatform = (): string => {
  if (typeof window === 'undefined') return 'web'
  return window.innerWidth < 768 ? 'mweb' : 'web'
}

const getUserType = (): string => {
  try {
    return localStorage.getItem(AMBASSADOR_USER_TYPE_KEY) || ''
  } catch {
    return ''
  }
}

const getCouponStatus = (profile: AmbassadorProfile): string => {
  if (profile?.couponStatus) {
    return String(profile.couponStatus).toLowerCase() === 'active'
      ? 'active'
      : 'inactive'
  }
  if (profile?.programme_type) return 'active'
  return ''
}

export const getGlobalProperties = (): GlobalEventProperties => {
  const profile = getProfile()
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  return {
    platform: getPlatform(),
    ambassador_user_id: user?.id || '',
    user_type: getUserType(),
    programme_type: profile?.programType ?? '',
    application_status: profile?.applicationStatus
      ? String(profile.applicationStatus).toLowerCase()
      : '',
    coupon_status: getCouponStatus(profile),
  }
}
